export const CANCELLATION_REASONS = [
  { value: "too_expensive", label: "It costs too much" },
  { value: "unused", label: "I am not using it enough" },
  { value: "missing_features", label: "It is missing something I need" },
  {
    value: "switched_service",
    label: "I am moving to another accountant or app",
  },
  { value: "too_complex", label: "It is too hard to use" },
  { value: "customer_service", label: "I am unhappy with the service" },
  { value: "low_quality", label: "It does not work well enough" },
  {
    value: "business_closed",
    label: "My business is closing or taking a break",
  },
  { value: "other", label: "Something else" },
] as const;

export type CancellationReasonId = typeof CANCELLATION_REASONS[number]["value"];
